import { useSelector } from "react-redux";
import { Outlet, useLocation } from "react-router";
import Header from "../core/common/header";
import Sidebar from "../core/common/sidebar";
import ThemeSettings from "../core/common/theme-settings";
import { useState } from "react";
import StackedSidebar from "../core/common/stacked-sidebar";
import DeleteModal from "../core/modals/deleteModal";
const Feature = () => {
  const [showLoader, setShowLoader] = useState(true);
  const headerCollapse = useSelector((state: any) => state.themeSetting.headerCollapse);
  const mobileSidebar = useSelector(
    (state: any) => state.sidebarSlice.mobileSidebar
  );
  const miniSidebar = useSelector(
    (state: any) => state.sidebarSlice.miniSidebar
  );
  const expandMenu = useSelector((state: any) => state.sidebarSlice.expandMenu);
  const dataWidth = useSelector((state: any) => state.themeSetting.dataWidth);
  const dataLayout = useSelector((state: any) => state.themeSetting.dataLayout);
  const dataLoader = useSelector((state: any) => state.themeSetting.dataLoader);
  const dataTheme = useSelector((state: any) => state.themeSetting.dataTheme);
  const dataSidebarAll = useSelector((state: any) => state.themeSetting.dataSidebarAll);
  const dataColorAll = useSelector((state: any) => state.themeSetting.dataColorAll);
  const dataTopBarColorAll = useSelector((state: any) => state.themeSetting.dataTopBarColorAll);
  const dataTopbarAll = useSelector((state: any) => state.themeSetting.dataTopbarAll);
  const location = useLocation();

  // useEffect(() => {
  //   if (dataLoader === 'enable') {
  //     setShowLoader(true);
  //     const timeoutId = setTimeout(() => {
  //       setShowLoader(false);
  //     }, 100);

  //     return () => {
  //       clearTimeout(timeoutId);
  //     };
  //   } else {
  //     setShowLoader(false);
  //   }
  //   window.scrollTo(0, 0);
  // }, [location.pathname, dataLoader]);

  const Preloader = () => {
    return (
      <div id="global-loader">
        <div className="page-loader"></div>
      </div>
    );
  };
  return (
    <>
      <style>
        {`
      :root {
        --sidebar--rgb-picr: ${dataSidebarAll};
        --topbar--rgb-picr:${dataTopbarAll};
        --topbarcolor--rgb-picr:${dataTopBarColorAll};
        --primary-rgb-picr:${dataColorAll};
      }
    `}
      </style>
      <div
        className={`
       ${dataLayout === "mini" || dataWidth === 'box' ? "mini-sidebar" : ''}
       ${dataLayout === "horizontal" || dataLayout === "horizontal-single" || dataLayout === "horizontal-overlay" || dataLayout === "horizontal-box" ? 'menu-horizontal' : ''}
      ${miniSidebar && dataLayout !== "mini" ? "mini-sidebar" : ""}
      ${dataWidth === 'box' ? 'layout-box-mode' : ''} ${headerCollapse ? "header-collapse" : ""}
     ${(expandMenu && miniSidebar) ||
            (expandMenu && dataLayout === "mini")
            ? "expand-menu"
            : ""
          }
      
      `}
      >
        <>
          {showLoader ?
            <>
              {/* <Preloader /> */}
              <div
                className={`main-wrapper ${mobileSidebar ? "slide-nav" : ""}`}>
                {/* {showLoader && <Preloader />} */}
                <Header />
                <Sidebar />
                <StackedSidebar />
                <Outlet />
                <DeleteModal />
                {!location.pathname.includes("layout") && <ThemeSettings />}
              </div>
            </> :
            <>
              <div
                className={`main-wrapper 
        ${mobileSidebar ? "slide-nav" : ""}`}
              >
                <Header />
                <Sidebar />
                <StackedSidebar />
                <Outlet />
                <DeleteModal />
                {!location.pathname.includes("layout") && <ThemeSettings />}
              </div>
            </>}

        </>
        {/* <Loader/> */}

        <div className="sidebar-overlay"></div>
      </div>
    </>
  );
};

export default Feature;
